import {
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import { appelerApi, verifier, CLE_TABLE_COURSES } from './api.ts'

// Suppression d'une course ajoutee par l'utilisateur (DELETE /api/events/{id}).
export default function useDeleteCourse() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (courseId: string) => {
      await verifier(await appelerApi('/api/events/' + encodeURIComponent(courseId), 'DELETE'), [204]);
    },
    onSettled: () => queryClient.invalidateQueries({ queryKey: CLE_TABLE_COURSES }),
  });
}
